import { AnySchema } from 'ajv';

import { DateFilterFields } from '../../dateFilter.models';

export const singleDateFilterSchema: AnySchema | any = {
  type: 'object',
  properties: {},
  required: [DateFilterFields.Dates],
};
